import React, { useMemo } from "react";
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";

export default function RichTextEditor({
  value,
  onChange,
  placeholder = "Write something...",
  className = "",
}) {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        ["link"],
        ["clean"],
      ],
      clipboard: {
        matchVisual: false,
      },
    }),
    []
  );

  const formats = useMemo(
    () => [
      "header",
      "bold",
      "italic",
      "underline",
      "list",
      "bullet",
      "blockquote",
      "code-block",
      "link",
    ],
    []
  );

  return (
    <div className={`pvRichTextEditor ${className}`.trim()}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={(html) => onChange?.(html)}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
      />
    </div>
  );
}

